import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import GameButton from '@/shared/GameComponents/UI/GameAnswerButton/GameButton';
import useCoverMenu from './useCoverMenu.hook';
import GameCoverMenu from '@/shared/GameComponents/UI/CoverMenu/CoverMenu';

export default function CoverMenu({
  activity,
  activityConf,
  isTask,
  coverImageSrc,
  gameActions,
}) {
  const { state } = useCoverMenu({
    activity,
    activityConf,
    gameActions,
  });

  return (
    <GameCoverMenu activity={activity} coverImageSrc={coverImageSrc}>
      {
        {
          TYPE: state.availableTypes.map((type) => (
            <GameButton
              type="primary"
              key={type}
              onClick={() => {
                gameActions.setGameConf({
                  ...activityConf,
                  miniactivityType: type,
                });
              }}
            >
              {typeLabel('storyWithQuestions', null, type)}
            </GameButton>
          )),
          START: (
            <>
              <GameButton type="primary" onClick={gameActions.startGame}>
                START
              </GameButton>
              {state.availableTypes.length > 1 && !isTask ? (
                <GameButton
                  type="secondary"
                  onClick={() => {
                    gameActions.setGameConf({
                      ...activityConf,
                      miniactivityType: null,
                    });
                  }}
                >
                  BACK
                </GameButton>
              ) : null}
            </>
          ),
        }[state.screen]
      }
    </GameCoverMenu>
  );
}
